/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_NewsInputs */

const ja_nav_news = /** @type {(inputs: Nav_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせ`)
};

const en_nav_news = /** @type {(inputs: Nav_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEWS`)
};

/**
* | output |
* | --- |
* | "NEWS" |
*
* @param {Nav_NewsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_news = /** @type {((inputs?: Nav_NewsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_NewsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_nav_news(inputs)
	return en_nav_news(inputs)
});